module.exports = __webpack_public_path__ + "static/media/4_apollo.17b7665b.svg";